var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "property-title-time-picker-loading-placeholder" },
      [
        _c("div", {
          staticClass:
            "icon icon-loading property-title-time-picker-loading-placeholder__icon"
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }